var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('great'),_c('title-transaction',{staticStyle:{"margin-top":"-12px"},attrs:{"title":"Últimas transações"}}),_c('resume-transactions'),_c('modal-open-call-cellphone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }